export default __webpack_public_path__ + "alberta-change-of-supplier.332bd11dbbe5d4c94bb0.svg";